import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGoBack } from 'hooks/useGoBack';
import { CardActionsButtons } from 'shared/mui/Card';
import { IconButton } from 'shared/mui/IconButtons';
import { PageHeader } from 'shared/mui/PageHeader';
import { Stack } from 'shared/mui/Stack/Stack';
import { TypographyTitle } from 'shared/mui/Typography';
import { CreateGuesserProps } from 'shared/react-admin/Guessers';

import { BoxStyled, StyledCreateGuesser } from './CreateGuesserPage.styled';

export type CreateGuesserPageProps = {
  title: string;
  children: React.ReactNode;
  leftActionsSlot?: JSX.Element | JSX.Element[];
  listName: string;
  rightActionsSlot?: JSX.Element | JSX.Element[];
} & CreateGuesserProps;

export function CreateGuesserPage({
  title,
  leftActionsSlot,
  listName,
  rightActionsSlot,
  children,
  ...props
}: CreateGuesserPageProps): JSX.Element {
  const { goBack } = useGoBack();

  return (
    <BoxStyled>
      <PageHeader
        breadCrumbs={{
          currentPage: title,
          listName,
        }}
      />
      <StyledCreateGuesser actions={false} toolbar={false} {...props}>
        <Stack alignItems="center" direction="row" gap={1}>
          <IconButton onClick={goBack}>
            <ArrowBackIcon />
          </IconButton>
          <TypographyTitle fontWeight={500} lineHeight={1} size="small">
            {title}
          </TypographyTitle>
        </Stack>
        {children}
        <CardActionsButtons
          leftActionsSlot={leftActionsSlot}
          rightActionsSlot={rightActionsSlot}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </StyledCreateGuesser>
    </BoxStyled>
  );
}
